import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/customers/customer-payment-method/:customerPaymentMethodId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    customerPaymentMethodId: string;
}
const mutationFn = ({ customerPaymentMethodId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { customerPaymentMethodId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteCustomerPaymentMethod };
